import React, { useState } from "react";
import cx from 'classnames';

import { WORKOUT_SHEET_STATE } from 'graphql/mutations';

import apolloClient from './apollo-client';

export default function WorkoutSheetStatus({ id, state_label, ...props }) {

  const [state, setState] = useState(props.state);

  const activate = () => {
    apolloClient.mutate({
      mutation: WORKOUT_SHEET_STATE,
      variables: { id, state: 'active' }
    }).then(result => {
      if (result.errors) {
        console.error('Error activating workout sheet:', result.errors);
        alert('Errore durante l\'attivazione della scheda. Riprova.');
      } else {
        setState('active');
      }
    }).catch(error => {
      console.error('Error activating workout sheet:', error);
      alert('Errore durante l\'attivazione della scheda. Riprova.');
    });
  }

  return (
    <div className="flex items-center">
      <span className={cx('font-medium capitalize px-2 inline-flex text-xs leading-5 rounded-full', { ['bg-p4-600 text-white']: state != 'active', ['bg-green-100 text-green-800']: state == 'active' })}>
        {state == 'active' ? 'Attiva' : state_label}
      </span>
      {(state == 'draft' || state == 'archived') && (<div className="btn ml-4" onClick={activate}>Attiva</div>)}
    </div>
  );
}
